import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import { bindActionCreators } from 'redux';
import UIActions from 'actions/UIActions';

import applySection from 'hocs/applySection';
import BankStatementIcon from 'assets/icons/BankStatement.svg';
import BankStatementFrame from './BankStatementFrame/BankStatementFrame';

import * as UISelectors from 'selectors/UISelectors';
import * as applicationSelectors from 'selectors/applicationSelectors';
import * as clientSelectors from 'selectors/clientSelectors';
import * as dataCollectionSelectors from 'selectors/dataCollectionSelectors';
import * as advisorSelectors from 'selectors/advisorSelectors';

class BankStatementsApply extends Component {
  render() {
    const {
      clientId,
      familyContactId,
      applicationId,
      selectedProcesses,
      setPageError,
      illionDocuments,
      advisor,
    } = this.props;

    return (
      <div>
        <BankStatementFrame
          clientId={clientId}
          familyContactId={familyContactId}
          applicationId={applicationId}
          setPageError={setPageError}
          selectedProcesses={selectedProcesses}
          illionDocuments={illionDocuments}
          advisor={advisor}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isSpinnerLoading: UISelectors.hasActiveSpinners(state),
  clientId: clientSelectors.getPrimaryApplicantId(state),
  familyContactId: clientSelectors.primaryApplicantContactId(state),
  applicationId: applicationSelectors.getApplicationId(state),
  selectedProcesses: dataCollectionSelectors.selectedProcesses(state),
  illionDocuments: applicationSelectors.illionDocuments(state),
  advisor: advisorSelectors.advisor(state),
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      startAnimationSequence: UIActions.startAnimationSequence,
      setPageError: UIActions.setPageError,
    },
    dispatch,
  );
};
const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onSubmit: () => {
    ownProps.onSubmit();
  },
});

export const messages = defineMessages({
  title: {
    id: 'BankStatementsApply.title',
    defaultMessage: 'Bank Statements',
  },
  titleDescription: {
    id: 'BankStatementsApply.titleDescription',
    defaultMessage: 'Securely provide a copy of your bank statement',
  },
  titleDescriptionEmpty: {
    id: 'BankStatementsApply.titleDescriptionEmpty',
    defaultMessage: 'Securely provide a copy of your bank statement',
  },
  headerDescription: {
    id: 'BankStatementsApply.headerDescription',
    defaultMessage: '',
  },
});

export const furtherDecoration = (props) => {
  const {
    totalDocuments: fileCount,
    intl: { formatMessage },
  } = props;
  const postfix = fileCount === 0 ? 'Empty' : '';

  return {
    title: formatMessage(messages.title),
    titleDescription: formatMessage(messages[`titleDescription${postfix}`], {
      fileCount,
    }),
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
  )(
    applySection({
      svgName: BankStatementIcon,
      furtherDecoration,
    })(BankStatementsApply),
  ),
);
